import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const HIGH_LEVEL_CATEGORIES_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('HIGH_LEVEL_CATEGORIES');
export const HIGH_LEVEL_CATEGORIES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	HIGH_LEVEL_CATEGORIES_CRUD_ACTION_CONSTANTS
);
